<template>
  <div>
    <label
      class="tag-listing-filters-tag-entry-label"
    >
      <input
        class="tag-listing-filters-tag-entry-input"
        type="checkbox"
        :checked="isFilterUsed(group, entry)"
        @click='filteringLocationManage(group, entry)'
      >
      <a
        class="tag-listing-filters-tag-entry-link"
        :href="builtQueryString"
        :title="entryDisplayValue(group, entry)"
        rel="nofollow"
      >
        <span
          v-if="group.tagDisplayType !== 'hex-color'"
          class="tag-listing-filters-tag-entry-name"
        >
          {{ entryDisplayValue(group, entry, { trim: true }) }}
        </span>
      </a>
    </label>
  </div>
</template>

<script>

import TagListingFiltersMixin from '../Mixins/TagListingFiltersMixin'

export default {
  name: 'EntryFilter',
  mixins: [TagListingFiltersMixin],
  props: {
    group: {
      tagDisplayType: '',
      tagGroupId: '',
      tagGroupName: null,
      tagGroupStep: 0,
      tagGroupDisplayPosition: 0,
      tags: []
    },
    entry: {
      tagDisplayValue: '',
      tagId: '',
      tagName: '',
      tagOrder: '',
      tagAllSlug: ''
    }
  },
  computed: {
    builtQueryString () {
      return this.filteringManage(this.group, this.entry)
    }
  }
}
</script>
